import React, { useState } from "react";
import {
  Alert,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { useUsersApi } from "../../services/users";
import { notifySuccess } from "../../services/notify";

// Asks before deleting: unlike a transaction row, a deleted account cannot be
// brought back. `user` is the row being deleted.
export const DeleteUserModal = ({ isOpen, user, toggle, onDeleted }) => {
  const usersApi = useUsersApi();
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const finish = () => {
    setError(null);
    toggle();
  };

  // What the user can trigger; not while a request is in flight.
  const close = () => {
    if (!submitting) finish();
  };

  const onDelete = async () => {
    setSubmitting(true);
    try {
      await usersApi.remove(user.id);
    } catch (caught) {
      setError(caught.message);
      setSubmitting(false);
      return;
    }
    setSubmitting(false);
    notifySuccess(`Deleted ${user.email}`);
    onDeleted();
    finish();
  };

  return (
    <Modal isOpen={isOpen} toggle={close} centered>
      <ModalHeader toggle={close}>Delete user</ModalHeader>
      <ModalBody style={{ fontSize: "13px" }}>
        <p>
          Delete <strong>{user.email}</strong>? They will no longer be able to
          sign in. This cannot be undone.
        </p>
        {/* ADC keys its Mongo data on the email address, not the Logto user. */}
        <p className="mb-0" style={{ color: "#575757" }}>
          Their transactions and other data in ADC are kept. A new account with
          the same email would see them again.
        </p>
        {error ? (
          <Alert
            color="danger"
            className="mt-3 mb-0"
            style={{ fontSize: "13px" }}
            data-testid="delete-user-error"
          >
            {error}
          </Alert>
        ) : null}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" outline onClick={close} disabled={submitting}>
          Cancel
        </Button>
        <Button color="danger" onClick={onDelete} disabled={submitting}>
          {submitting ? "Deleting..." : "Delete user"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
